import { object, ref, string } from 'yup';
import { ValidationErrorMessages } from './types';
// import { isPasswordValid } from './helpers/validators';
export const changePasswordValidation = object({
    oldPassword: string()
        .required(ValidationErrorMessages.REQUIRED)
        .min(8, ValidationErrorMessages.LENGTH),
    password: string()
        .required(ValidationErrorMessages.REQUIRED)
        .min(8, ValidationErrorMessages.LENGTH),
    // .test({
    //   test: (value) => isPasswordValid(value),
    // }),
    confirmPassword: string()
        .required(ValidationErrorMessages.REQUIRED)
        .oneOf([ref('password')], ValidationErrorMessages.CONFIRM_PASSWORD),
});
//# sourceMappingURL=changePasswordValidation.js.map